var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('@babel/core'),
    transformSync = _require.transformSync;

var styleToObject = require('style-to-object');

var camelCaseCSS = require('camelcase-css');

var uniq = require('lodash.uniq');

var _require2 = require('@mdx-js/util'),
    paramCase = _require2.paramCase,
    toTemplateLiteral = _require2.toTemplateLiteral;

var BabelPluginApplyMdxProp = require('babel-plugin-apply-mdx-type-prop');

var BabelPluginExtractImportNames = require('babel-plugin-extract-import-names'); // From https://github.com/wooorm/property-information/blob/ca74feb1fcd40753367c75b63c893353cd7d8c70/lib/html.js


var spaceSeparatedProperties = ['acceptCharset', 'accessKey', 'autoComplete', 'className', 'controlsList', 'headers', 'htmlFor', 'httpEquiv', 'itemProp', 'itemRef', 'itemType', 'ping', 'rel', 'sandbox']; // eslint-disable-next-line complexity

function toJSX(node) {
  var parentNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$skipExport = options.skipExport,
      skipExport = _options$skipExport === void 0 ? false : _options$skipExport,
      _options$preserveNewl = options.preserveNewlines,
      preserveNewlines = _options$preserveNewl === void 0 ? false : _options$preserveNewl,
      wrapExport = options.wrapExport;
  var children = '';

  if (node.properties != null) {
    // Turn style strings into JSX-friendly style object
    if (typeof node.properties.style === 'string') {
      var styleObject = {};
      styleToObject(node.properties.style, function (name, value) {
        styleObject[camelCaseCSS(name)] = value;
      });
      node.properties.style = styleObject;
    } // Transform class property to JSX-friendly className


    if (node.properties.class) {
      node.properties.className = node.properties.class;
      delete node.properties.class;
    } // AriaProperty => aria-property
    // dataProperty => data-property


    var paramCaseRe = /^(aria[A-Z])|(data[A-Z])/;
    node.properties = Object.entries(node.properties).reduce(function (properties, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return Object.assign({}, properties, _defineProperty({}, paramCaseRe.test(key) ? paramCase(key) : key, value));
    }, {});
  }

  if (node.type === 'root') {
    var importNodes = [];
    var exportNodes = [];
    var jsxNodes = [];
    var layout;

    var _iterator = _createForOfIteratorHelper(node.children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var childNode = _step.value;

        if (childNode.type === 'import') {
          importNodes.push(childNode);
          continue;
        }

        if (childNode.type === 'export') {
          if (childNode.default) {
            layout = childNode.value.replace(/^export\s+default\s+/, '').replace(/;\s*$/, '');
            continue;
          }

          exportNodes.push(childNode);
          continue;
        }

        jsxNodes.push(childNode);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var exportNames = exportNodes.map(function (node) {
      return node.value.match(/^export\s*(var|const|let|class|function)?\s*(\w+)/);
    }).map(function (match) {
      return Array.isArray(match) ? match[2] : null;
    }).filter(Boolean);
    var importStatements = importNodes.map(function (childNode) {
      return toJSX(childNode, node);
    }).join('\n');
    var exportStatements = exportNodes.map(function (childNode) {
      return toJSX(childNode, node);
    }).join('\n');
    var layoutProps = "const layoutProps = {\n  ".concat(exportNames.join(',\n'), "\n};");
    var mdxLayout = "const MDXLayout = ".concat(layout ? layout : '"wrapper"');
    var fn = "function MDXContent({ components, ...props }) {\n  return (\n    <MDXLayout\n      {...layoutProps}\n      {...props}\n      components={components}>\n".concat(jsxNodes.map(function (childNode) {
      return toJSX(childNode, node);
    }).join(''), "\n    </MDXLayout>\n  )\n};\nMDXContent.isMDXComponent = true"); // Check JSX nodes against imports

    var babelPluginExtractImportNamesInstance = new BabelPluginExtractImportNames();
    var filename = options.file && options.file.path;
    transformSync(importStatements, {
      filename: filename,
      configFile: false,
      babelrc: false,
      plugins: [require('@babel/plugin-syntax-jsx'), require('@babel/plugin-syntax-object-rest-spread'), babelPluginExtractImportNamesInstance.plugin]
    });
    var importNames = babelPluginExtractImportNamesInstance.state.names;
    var babelPluginApplyMdxPropInstance = new BabelPluginApplyMdxProp();
    var babelPluginApplyMdxPropToExportsInstance = new BabelPluginApplyMdxProp();
    var fnPostMdxTypeProp = transformSync(fn, {
      filename: filename,
      configFile: false,
      babelrc: false,
      plugins: [require('@babel/plugin-syntax-jsx'), require('@babel/plugin-syntax-object-rest-spread'), babelPluginApplyMdxPropInstance.plugin]
    }).code;
    var exportStatementsPostMdxTypeProps = transformSync(exportStatements, {
      filename: filename,
      configFile: false,
      babelrc: false,
      plugins: [require('@babel/plugin-syntax-jsx'), require('@babel/plugin-syntax-object-rest-spread'), babelPluginApplyMdxPropToExportsInstance.plugin]
    }).code;
    var allJsxNames = [].concat(_toConsumableArray(babelPluginApplyMdxPropInstance.state.names), _toConsumableArray(babelPluginApplyMdxPropToExportsInstance.state.names));
    var jsxNames = allJsxNames.filter(function (name) {
      return name !== 'MDXLayout';
    });
    var importExportNames = importNames.concat(exportNames);
    var shortCodeDef = "const makeShortcode = name => function MDXDefaultShortcode(props) {\n      console.warn(\"Component \" + name + \" was not imported, exported, or provided by MDXProvider as global scope\")\n      return <div {...props}/>\n    };\n";
    var fakedModulesForGlobalScope = uniq(jsxNames).filter(function (name) {
      return !importExportNames.includes(name);
    }).map(function (name) {
      return "const ".concat(name, " = makeShortcode(\"").concat(name, "\");");
    }).join('\n');
    var fakedModules = fakedModulesForGlobalScope && [shortCodeDef, fakedModulesForGlobalScope].join('') || '';
    var moduleBase = "".concat(importStatements, "\n").concat(exportStatementsPostMdxTypeProps, "\n").concat(fakedModules, "\n").concat(layoutProps, "\n").concat(mdxLayout);

    if (skipExport) {
      return "".concat(moduleBase, "\n").concat(fnPostMdxTypeProp);
    }

    if (wrapExport) {
      return "".concat(moduleBase, "\n").concat(fnPostMdxTypeProp, "\nexport default ").concat(wrapExport, "(MDXContent)");
    }

    return "".concat(moduleBase, "\nexport default ").concat(fnPostMdxTypeProp);
  } // Recursively walk through children


  if (node.children) {
    children = node.children.map(function (childNode) {
      var childOptions = Object.assign({}, options, {
        // Tell all children inside <pre> tags to preserve newlines as text nodes
        preserveNewlines: preserveNewlines || node.tagName === 'pre'
      });
      return toJSX(childNode, node, childOptions);
    }).join('');
  }

  if (node.type === 'element') {
    var props = '';

    if (node.properties) {
      spaceSeparatedProperties.forEach(function (prop) {
        if (Array.isArray(node.properties[prop])) {
          node.properties[prop] = node.properties[prop].join(' ');
        }
      });

      if (Object.keys(node.properties).length > 0) {
        props = JSON.stringify(node.properties);
      }
    }

    return "<".concat(node.tagName).concat(parentNode.tagName ? " parentName=\"".concat(parentNode.tagName, "\"") : '').concat(props ? " {...".concat(props, "}") : '', ">").concat(children, "</").concat(node.tagName, ">");
  } // Wraps text nodes inside template string, so that we don't run into escaping issues.


  if (node.type === 'text') {
    // Don't wrap newlines unless specifically instructed to by the flag,
    // to avoid issues like React warnings caused by text nodes in tables.
    var shouldPreserveNewlines = preserveNewlines || parentNode.tagName === 'p';

    if (node.value === '\n' && !shouldPreserveNewlines) {
      return node.value;
    }

    return toTemplateLiteral(node.value);
  }

  if (node.type === 'comment') {
    return "{/*".concat(node.value, "*/}");
  }

  if (node.type === 'import' || node.type === 'export' || node.type === 'jsx') {
    return node.value;
  }
}

function compile() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  this.Compiler = function (tree, file) {
    return toJSX(tree, {}, _objectSpread({
      file: file || {}
    }, options));
  };
}

module.exports = compile;
exports = compile;
exports.toJSX = toJSX;
exports.default = compile;